import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UnderlineMarkerIcon = function UnderlineMarkerIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 16 16",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#23263B",
      d: "M8 2.666c1.287 0 3.333.934 3.333 3.434 0 1.44-1.146 3.113-3.333 4.88C5.813 9.213 4.667 7.533 4.667 6.1c0-2.5 2.046-3.434 3.333-3.434zm0-1.333c-2.18 0-4.667 1.64-4.667 4.767 0 2.08 1.554 4.273 4.667 6.566 3.113-2.293 4.667-4.486 4.667-6.566 0-3.127-2.487-4.767-4.667-4.767z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#23263B",
      d: "M8 4.667c-.733 0-1.333.6-1.333 1.333A1.333 1.333 0 108 4.667zm-4.667 8.667h9.334v1.333H3.333v-1.333z"
    })]
  });
};